module.exports = __webpack_public_path__ + "static/media/input_file_white.86dd2f12.svg";